(function () {
  function initBooking(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var form = root.querySelector('form');
    var vinInput = root.querySelector('#FastLaneVin');
    var decodeButton = root.querySelector('[data-decode-vin]');
    var vinFeedback = root.querySelector('[data-vin-feedback]');
    var vehicleDetails = root.querySelector('#VehicleDetails');
    var selectedServices = root.querySelector('#SelectedServices');
    var selectedAppointment = root.querySelector('#SelectedAppointment');
    var submitButton = root.querySelector('[data-submit-booking]');
    var submitMessage = root.querySelector('[data-submit-message]');
    var privacyAccept = root.querySelector('[data-privacy-accept]');
    var vinDecoded = false;

    privacyAccept.addEventListener('change', function () {
      if (privacyAccept.checked && submitMessage.textContent.indexOf('Privacy Policy') !== -1) submitMessage.textContent = '';
    });

    submitButton.addEventListener('click', function () {
      var invalidField = form.querySelector(':invalid');
      if (!invalidField) return;
      if (invalidField === privacyAccept) submitMessage.textContent = 'Please read and accept the Privacy Policy before continuing to payment.';
      else submitMessage.textContent = 'Please complete all required booking information before continuing to payment.';
    });

    vinInput.addEventListener('input', function () {
      vinInput.value = vinInput.value.toUpperCase().replace(/[^A-HJ-NPR-Z0-9]/g, '').slice(0, 17);
      vinDecoded = false;
      vehicleDetails.value = '';
      vinFeedback.className = 'vin-feedback';
      vinFeedback.innerHTML = '<p>Enter the 17-character VIN found on the dashboard or driver-side door jamb.</p>';
    });

    decodeButton.addEventListener('click', async function () {
      if (vinInput.value.length !== 17) {
        vinFeedback.className = 'vin-feedback error';
        vinFeedback.innerHTML = '<p>Please enter all 17 VIN characters. VINs do not use I, O, or Q.</p>';
        return;
      }
      decodeButton.disabled = true;
      decodeButton.textContent = 'Decoding…';
      try {
        var response = await fetch('https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVinValuesExtended/' + encodeURIComponent(vinInput.value) + '?format=json');
        var data = await response.json();
        var result = data && data.Results && data.Results[0];
        if (!response.ok || !result || (!result.Make && !result.Model && !result.ModelYear)) throw new Error('No vehicle found');
        var title = [result.ModelYear, result.Make, result.Model, result.Trim || result.Series].filter(Boolean).join(' ');
        var details = [result.BodyClass, result.EngineCylinders && result.EngineCylinders + ' cyl', result.DisplacementL && result.DisplacementL + 'L', result.FuelTypePrimary].filter(Boolean).join(' · ');
        vehicleDetails.value = title + (details ? ' — ' + details : '');
        vinDecoded = true;
        vinFeedback.className = 'vin-feedback success';
        vinFeedback.innerHTML = '<div class="vehicle-result"><span class="vehicle-icon">✓</span><div><small>VEHICLE FOUND</small><strong>' + escapeHtml(title) + '</strong><p>' + escapeHtml(details) + '</p></div></div><p>Vehicle details will be included with your request.</p>';
      } catch (error) {
        vinDecoded = false;
        vehicleDetails.value = '';
        vinFeedback.className = 'vin-feedback error';
        vinFeedback.innerHTML = '<p>We couldn’t decode that VIN. Check the characters and try again.</p>';
      } finally {
        decodeButton.disabled = false;
        decodeButton.textContent = 'Decode VIN';
      }
    });

    var serviceOptions = Array.prototype.slice.call(root.querySelectorAll('[data-service-option]'));
    var serviceSummary = root.querySelector('[data-service-summary]');
    serviceOptions.forEach(function (option) {
      option.addEventListener('change', function () {
        var chosen = serviceOptions.filter(function (item) { return item.checked; }).map(function (item) { return item.value; });
        selectedServices.value = chosen.join(', ');
        serviceSummary.textContent = chosen.length === 0 ? 'Choose services' : chosen.length === 1 ? chosen[0] : chosen.length + ' services selected';
      });
    });
    root.querySelector('[data-close-services]').addEventListener('click', function () { root.querySelector('.service-dropdown').open = false; });

    var dateSelect = root.querySelector('#AppointmentDate');
    var timesBox = root.querySelector('[data-appointment-times]');
    var prompt = root.querySelector('[data-appointment-prompt]');
    var appointmentSummary = root.querySelector('[data-appointment-summary]');
    var closeAppointment = root.querySelector('[data-close-appointment]');
    var times = ['08:30', '09:00', '09:30', '10:00', '10:30'];
    getBookableDates().forEach(function (date) {
      var option = document.createElement('option');
      option.value = date;
      option.textContent = formatDate(date);
      dateSelect.appendChild(option);
    });
    dateSelect.addEventListener('change', function () {
      selectedAppointment.value = '';
      closeAppointment.disabled = true;
      appointmentSummary.textContent = 'Choose an appointment';
      timesBox.innerHTML = '';
      prompt.hidden = true;
      timesBox.hidden = false;
      times.forEach(function (time) {
        var label = document.createElement('label');
        label.className = 'appointment-time';
        label.innerHTML = '<input type="radio" name="appointment-choice" value="' + dateSelect.value + '|' + time + '"><span>' + formatTime(time) + '</span>';
        label.querySelector('input').addEventListener('change', function () {
          selectedAppointment.value = formatDate(dateSelect.value) + ' at ' + formatTime(time);
          appointmentSummary.textContent = selectedAppointment.value;
          closeAppointment.disabled = false;
        });
        timesBox.appendChild(label);
      });
    });
    closeAppointment.addEventListener('click', function () { root.querySelector('.appointment-dropdown').open = false; });

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      submitMessage.textContent = '';
      if (!vinDecoded) { submitMessage.textContent = 'Please decode the VIN before continuing.'; vinInput.focus(); return; }
      if (!selectedServices.value) { submitMessage.textContent = 'Please select at least one service.'; root.querySelector('.service-dropdown').open = true; return; }
      if (!selectedAppointment.value) { submitMessage.textContent = 'Please choose an appointment.'; root.querySelector('.appointment-dropdown').open = true; return; }
      if (!privacyAccept.checked) { submitMessage.textContent = 'Please read and accept the Privacy Policy before continuing to payment.'; privacyAccept.focus(); return; }
      var variantId = String(root.dataset.variantId || '').trim();
      if (!/^\d+$/.test(variantId)) { submitMessage.textContent = 'The inspection payment product is not configured. Please contact Fast Lane.'; return; }
      submitButton.disabled = true;
      submitButton.firstChild.textContent = 'Opening secure checkout… ';
      try {
        var shopRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
        var cartResponse = await fetch(shopRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: {
            'VIN': vinInput.value,
            'Vehicle': vehicleDetails.value,
            'Services': selectedServices.value,
            'Appointment': selectedAppointment.value,
            'Customer name': root.querySelector('#ContactFormName').value,
            'Contact number': root.querySelector('#ContactFormPhone').value,
            'Email': root.querySelector('#ContactFormEmail').value,
            'Vehicle concern': root.querySelector('#ContactFormConcern').value || 'Not provided',
            'Inspection fee accepted': 'Yes',
            'Privacy policy accepted': 'Yes — July 15, 2026'
          } }] })
        });
        if (!cartResponse.ok) {
          var cartError = await cartResponse.json().catch(function () { return {}; });
          throw new Error(cartError.description || cartError.message || 'Shopify could not add the inspection to checkout.');
        }
        window.location.assign(shopRoot + 'checkout');
      } catch (error) {
        submitButton.disabled = false;
        submitButton.firstChild.textContent = 'Pay & Book Inspection ';
        submitMessage.textContent = error && error.message ? error.message : 'Checkout could not be opened. Please try again.';
      }
    });
  }

  function getBookableDates() {
    var dates = [];
    var parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
    var value = function (type) { var part = parts.find(function (item) { return item.type === type; }); return part ? part.value : ''; };
    var start = new Date(Date.UTC(Number(value('year')), Number(value('month')) - 1, Number(value('day'))));
    for (var offset = 0; offset < 15; offset += 1) {
      var date = new Date(start);
      date.setUTCDate(start.getUTCDate() + offset);
      if (date.getUTCDay() !== 0 && date.getUTCDay() !== 6) dates.push(date.toISOString().slice(0, 10));
    }
    return dates;
  }
  function formatDate(date) { return new Intl.DateTimeFormat('en-US', { weekday: 'long', month: 'long', day: 'numeric', timeZone: 'UTC' }).format(new Date(date + 'T12:00:00Z')); }
  function formatTime(time) { var hour = Number(time.split(':')[0]); return (hour > 12 ? hour - 12 : hour) + ':' + time.split(':')[1] + (hour >= 12 ? ' PM' : ' AM'); }
  function escapeHtml(value) { var div = document.createElement('div'); div.textContent = value || ''; return div.innerHTML; }

  function initPrivacy(panel) {
    if (!panel) return;
    var dialog = panel.querySelector('[data-privacy-dialog]');
    if (!dialog || dialog.dataset.initialized === 'true') return;
    dialog.dataset.initialized = 'true';
    panel.querySelectorAll('[data-open-privacy]').forEach(function (button) { button.addEventListener('click', function (event) { event.preventDefault(); event.stopPropagation(); dialog.showModal(); }); });
    dialog.querySelectorAll('[data-close-privacy]').forEach(function (button) { button.addEventListener('click', function () { dialog.close(); }); });
    dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
  }

  function init() { var panel = document.querySelector('[data-language-panel="en"]'); initBooking(panel && panel.querySelector('[data-fast-lane-booking]')); initPrivacy(panel); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
